if (!customElements.get('gift-note')) {
  customElements.define(
    'gift-note',
    class GiftNote extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.message = this.querySelector('textarea');
        this.checkbox.addEventListener('change', this.onChange.bind(this));
        this.onChange();
      }

      connectedCallback() {
        if (typeof subscribe === 'function') {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === 'product-form') {
              this.reset();
            }
          });
        }
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      onChange() {
        if (this.checkbox.checked) {
          this.message.disabled = false;
        } else {
          this.message.value = '';
          this.message.disabled = true;
        }
      }

      reset() {
        this.checkbox.checked = false;
        this.onChange();
      }
    }
  );
}
